import { useState } from 'react';
import { useFavorites } from '@/hooks/useFavorites';

type Props = {
  dramaId: string;
  title: string;
};

export default function FavoriteButton({ dramaId, title }: Props) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const [hint, setHint] = useState('');
  const active = isFavorite(dramaId);

  const onClick = () => {
    const nowActive = toggleFavorite(dramaId);
    setHint(nowActive ? `已将《${title}》加入收藏（仅保存在本机浏览器）` : '已取消收藏');
    window.setTimeout(() => setHint(''), 3000);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={onClick}
        className={`flex h-11 items-center gap-2 whitespace-nowrap rounded-md border px-5 text-sm font-semibold transition-colors ${
          active
            ? 'border-accent-500 bg-accent-500 text-primary-950'
            : 'border-background-50/40 bg-background-50/10 text-background-50 backdrop-blur hover:bg-background-50/20'
        }`}
      >
        <i className={`${active ? 'ri-heart-fill' : 'ri-heart-line'} text-lg`} />
        {active ? '已收藏' : '收藏'}
      </button>
      {hint && (
        <p className="absolute left-0 top-full mt-2 w-64 rounded-md bg-primary-950/90 px-3 py-2 text-xs text-background-50">
          {hint}
        </p>
      )}
    </div>
  );
}